import api from './api';

/**
 * Servicio para gestionar libros del MINEDU
 */
export const librosService = {
  /**
   * Obtiene todos los libros
   * @returns {Promise<Array>} Lista de libros
   */
  getAll: async () => {
    try {
      const response = await api.get('/libros');
      return response.data || [];
    } catch (error) {
      console.error('Error al obtener libros:', error);
      throw error;
    }
  },

  /**
   * Obtiene libros filtrados por área y grado
   * @param {number} areaId - ID del área curricular
   * @param {number} gradoId - ID del grado
   * @returns {Promise<Array>} Libros que coinciden con los filtros
   */
  getByAreaAndGrado: async (areaId, gradoId) => {
    try {
      const response = await api.get('/libros', {
        params: { 
          area_id: areaId, 
          grado_id: gradoId 
        }
      });
      return response.data || [];
    } catch (error) {
      console.error('Error al obtener libros por área y grado:', error);
      throw error;
    }
  },

  /**
   * Obtiene un libro específico por ID
   * @param {number} id - ID del libro
   * @returns {Promise<Object>} Datos del libro
   */
  getById: async (id) => {
    try {
      const response = await api.get(`/libros/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error al obtener libro ${id}:`, error);
      throw error;
    }
  },

  /**
   * Obtiene las sesiones de un libro específico
   * @param {number} libroId - ID del libro
   * @returns {Promise<Array>} Lista de sesiones del libro
   */
  getSesiones: async (libroId) => {
    try {
      const response = await api.get(`/libros/${libroId}/sesiones`);
      return response.data || [];
    } catch (error) {
      console.error(`Error al obtener sesiones del libro ${libroId}:`, error);
      throw error;
    }
  },
};

export default librosService;
